/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, ListItemText, Grid, Paper, Avatar } from "@material-ui/core";

// @material-ui/icons
import CommuteIcon from '@material-ui/icons/Commute';
import EmailIcon from '@material-ui/icons/Email';
import MobileIcon from '@material-ui/icons/PhoneIphone';

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";
import { withStyles } from '@material-ui/core/styles';

function Footer({ ...props }) {

  // inline-style
  const style = {
    margin: '52px 0'
  };

  const { classes, whiteFont, dataCustom, dataMenu } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });

  const dataTitle = dataCustom.filter((item) => item.custom_fields === "footer_title").map((item) => item.value);
  const dataList = dataCustom.filter(item => item.custom_fields === 'link_1' || item.custom_fields === 'link_2' || item.custom_fields === 'link_3' || item.custom_fields === 'link_4' );
  const dataInfoTitle = dataCustom.filter(item => item.custom_fields === 'contact_info_title');
  const dataAddress = dataCustom.filter(item => item.custom_fields === 'contact_info_address').map((item) => item.value);
  const dataAddressLink = dataCustom.filter(item => item.custom_fields === 'contact_info_address').map((item) => item.link);
  const dataEmail = dataCustom.filter(item => item.custom_fields === 'contact_info_email').map((item) => item.value);
  const dataEmailLink = dataCustom.filter(item => item.custom_fields === 'contact_info_email').map((item) => item.link);
  const dataTel = dataCustom.filter(item => item.custom_fields === 'contact_info_tel').map((item) => item.value);

  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div style={style} className={classes.row}>

          <Grid container spacing={24}>

            <Grid item xs={12} sm={6}>
              <List>
                <ListItem>
                  <ListItemText secondary={dataTitle} />
                </ListItem>
                {dataList.map(item =>
                  <ListItem>
                    <ListItemText secondary={ <a href={item.link}>{item.value}</a> } />
                  </ListItem>
                )}
              </List>
            </Grid>

            <Grid item xs={12} sm={6}>
              <List>
                <ListItem>
                  <Avatar>
                    <CommuteIcon />
                  </Avatar>
                  <ListItemText primary="Adress" secondary={ <a href={dataAddressLink} target="_blank">{dataAddress}</a> } />
                </ListItem>
                <ListItem>
                  <Avatar>
                    <EmailIcon />
                  </Avatar>
                  <ListItemText inset primary="Epost" secondary={ <a href={'mailto:' + dataEmailLink} target="_self">{dataEmail}</a> } />
                </ListItem>
                <ListItem>
                  <Avatar>
                    <MobileIcon />
                  </Avatar>
                  <ListItemText primary="Tel" secondary={ <a href="tel:+460723991800">{dataTel}</a> } />
                </ListItem>
              </List>
            </Grid>

          </Grid>

        </div>
        <div className={classes.left}>
          <List className={classes.list}>
            {dataMenu.map((item) =>
              <ListItem key={item.id} className={classes.inlineBlock}>
                <a
                  href={item.link}
                  className={classes.block}
                  target="_self"
                >
                  {item.title}
                </a>
              </ListItem>
            )}
          </List>
        </div>
        <div className={classes.right}>
          &copy; { 1900 + new Date().getYear() } , made by{" "}
          <a
            href="https://github.com/Regis011"
            target="_blank"
          >
            Regis011
          </a>{" "}
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx